exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-rule-index-tsx": () => import("./../../../src/pages/rule/index.tsx" /* webpackChunkName: "component---src-pages-rule-index-tsx" */),
  "component---src-pages-thanks-index-tsx": () => import("./../../../src/pages/thanks/index.tsx" /* webpackChunkName: "component---src-pages-thanks-index-tsx" */)
}

